function showCityInfo() {
    //实例化城市查询类
    let citysearch = new AMap.CitySearch();
    return new Promise((resolve, reject) => {
        //自动获取用户IP，返回当前城市
        citysearch.getLocalCity(function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
                if (result && result.city && result.bounds)resolve(result.city)
            } else {
                reject(result.info)
            }
        });
    })
}
export {
    showCityInfo
}
